export const SETTINGS_URL = Object.freeze({
  default: {
    name: 'settings',
    path: '/settings',
  },
});
